import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";
import {
  About,
  Explore,
  InterestedIn,
  Navigating,
  OurMission,
  Results,
} from "@/components/AboutUs";
import { Container } from "@mui/material";

const AboutUs = () => {
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, lg: 0 } }}>
        <BreadcrumbsNav />
      </Container>
      <About />
      <Navigating />
      <Results />
      <OurMission />
      <Explore />
      <InterestedIn />
    </>
  );
};

export default AboutUs;
